import React, { Component } from 'react';
import NewWindow from 'react-new-window';

const style = {
    width: "11.93in",
    border : "1px solid gray",
    margin : "1in"
}

class Payslip extends Component{

    // data = {
    //     "employee_name": "Umair Ramzan",
    //     "employee_address": "194/4,Bulugohattanna Road, Akurana.",
    //     "employee_nic": "952413147V",
    //     "salary_period" : "From 2020/08/10 To 2020/09/10",
    //     "salary": [
    //         {
    //             "earning_detail" : "Basic Salary",
    //             "earning_amount" : 25000,
    //             "deduction_detail" : "Salary Advance",
    //             "deduction_amount" : 2000
    //         }
    //     ],
    //     "total" : {
    //         "total_earnings": 25000,
    //         "total_deductions" : 2000
    //     }
    // }

   
    render(){
       const data = this.props.payslipData
        return(
            <>
        <NewWindow title="Employee Payslip">
            <div>
            <div style={{textAlign:"center", backgroundColor:"#d1d1d1"}}>
                <h1 style={{margin:0,padding:0 }}>RIB Group (pvt) Ltd</h1>      
                <h3  style={{margin:0,padding:0 }}>Employee Payslip</h3>        
            </div>
            <table className="salary-slip" style={{border:"1px solid black"}}>
                <tr style={{border:"1px solid black"}}>
                    <td colSpan="1" style={{border:"1px solid black" , minWidth:"1.5in"}}>Name</td>
                    <td colSpan="3" style={{border:"1px solid black" , minWidth:"1.5in"}}>{data["employee_name"]}</td>
                </tr>
                <tr style={{border:"1px solid black"}}>
                    <td colSpan="1" style={{border:"1px solid black" , minWidth:"1.5in"}}>NIC</td>
                    <td colSpan="3" style={{border:"1px solid black" , minWidth:"1.5in"}}>{data["employee_nic"]}</td>
                </tr>
                <tr style={{border:"1px solid black"}}>
                    <td colSpan="1" style={{border:"1px solid black" , minWidth:"1.5in"}}>Address</td>
                    <td colSpan="3" style={{border:"1px solid black" , minWidth:"1.5in"}}>{data["employee_address"]}</td>
                </tr>
                <tr style={{border:"1px solid black"}}>
                    <td colSpan="1" style={{border:"1px solid black" , minWidth:"1.5in"}}>Salary Period</td>
                    <td colSpan="3" style={{border:"1px solid black" , minWidth:"1.5in"}}>{data["salary_period"]}</td>
                </tr>
                <tr style={{border:"2px solid black" , backgroundColor:"#d1d1d1" , fontWeight:"bold"}}>
                  <td style={{border:"1px solid black" , minWidth:"1.5in"}}>Earings</td>
                  <td style={{border:"1px solid black" , minWidth:"1.5in"}}>Amount</td>
                  <td style={{border:"1px solid black" , minWidth:"1.5in"}}>Deductions</td>
                  <td style={{border:"1px solid black" , minWidth:"1.5in"}}>Amount</td>
                </tr>
                {
                    data.salary.map(sal => (<tr style={{border:"1px solid black"}}>
                    <td style={{border:"1px solid black" , minWidth:"1.5in"}}>{sal.earning_detail}</td>
                    <td style={{border:"1px solid black" , minWidth:"1.5in"  , textAlign:"right"}}>{sal.earning_amount}</td>
                    <td style={{border:"1px solid black" , minWidth:"1.5in" }}>{sal.deduction_detail}</td>
                    <td style={{border:"1px solid black" , minWidth:"1.5in"  , textAlign:"right"}}>{sal.deduction_amount}</td>
                  </tr>))
                }
                 <tr className="row-total" style={{border:"2px solid black" , backgroundColor:"#d1d1d1" , fontWeight:"bold"}}>
                  <td style={{border:"1px solid black" , minWidth:"1.5in"}}>Total Earings</td>
                  <td style={{border:"1px solid black" , minWidth:"1.5in" , textAlign:"right"}}>{data.total.total_earnings}</td>
                  <td style={{border:"1px solid black" , minWidth:"1.5in"}}>Total Deductions</td>
                  <td style={{border:"1px solid black" , minWidth:"1.5in"  , textAlign:"right"}}>{data.total.total_deductions}</td>
                </tr>
                <tr className="final-salary" style={{border:"2px solid black" , backgroundColor:"#d1d1d1" , fontWeight:"bold"}}>
                  <td colSpan="3" style={{border:"1px solid black" , minWidth:"1.5in"}}>Final Salary</td>
                  <td style={{border:"1px solid black" , minWidth:"1.5in"  , textAlign:"right"}}>{data.total.total_earnings - data.total.total_deductions}</td>
                </tr>
                <tr  style={{border:"1px solid black" }}>
                  <td colSpan="1" style={{border:"1px solid black" , minWidth:"1.5in"}}>Employee Signature</td>
                  <td colSpan="3" style={{border:"1px solid black" , minWidth:"1.5in"  , textAlign:"right"}}></td>
                </tr>
                <tr style={{border:"1px solid black"  }}>
                  <td colSpan="1" style={{border:"1px solid black" , minWidth:"1.5in"}}>Manager Signature</td>
                  <td colSpan="3" style={{border:"1px solid black" , minWidth:"1.5in"  , textAlign:"right"}}></td>
                </tr>
            </table>
            </div>
           
        </NewWindow>
        </>)
    }
}

export default Payslip